var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vue-flow-editor-icon",
      attrs: { "aria-hidden": "true" },
      on: { click: (e) => _vm.$emit("click", e) },
    },
    [_c("use", { attrs: { "xlink:href": "#" + _vm.icon } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }